import { post } from "../https";

const api = "/xywapi";
// 邀请赛事组织单位  获取验证码
export async function getChannelTelCode(data) {
  return await post(`${api}/inviteChannel/${data.tel}`, data);
}
// 邀请赛事组织单位  获取信息
export async function getChannelInfo(data) {
  return await post(`${api}/inviteChannel/detail/${data.code}`, data);
}

// 邀请赛事组织单位  提交信息
export async function commitInviteChannel(data) {
  return await post(`${api}/${data.url}`, data);
}

// 报名服务单位  获取验证码
export async function getInstitutionTelCode(data) {
  return await post(`${api}/inviteInstitution/${data.tel}`, data);
}

// 报名服务单位  获取信息
export async function getInstitutionInfo(data) {
  return await post(`${api}/inviteInstitution/detail/${data.code}`, data);
}


// 报名服务单位  提交信息
export async function commitInviteInstitution(data) {

  return await post(`${api}/${data.url}`, data);
}

// 专家  获取验证码
export async function getJudgeTelCode(data) {
  return await post(`${api}/inviteJudge/${data.tel}`, data);
}

// 专家  提交信息
export async function commitInviteJudge(data) {
  return await post(`${api}/${data.url}`, data);
}



// 专家  获取信息
export async function getJudgeInfo(data) {
  return await post(`${api}/inviteJudge/detail/${data.code}`, data);
}



// 获取所有的赛务专业
export async function getAllMajor(data) {
  return await post(`${api}/swMajor/getAllMajor`, data);
}

